import Keycloak from "keycloak-js";

import { config } from "./config";

/** Single shared Keycloak client for the app. */
export const keycloak = new Keycloak({
  url: config.keycloakUrl,
  realm: config.keycloakRealm,
  clientId: config.keycloakClientId,
});

/**
 * Which identity provider to jump straight to, skipping the Keycloak form. `?login=form` opts
 * out, keeping the seeded username/password accounts reachable outside local.
 */
export function loginIdpHint(search: string, idpHint: string): string {
  return new URLSearchParams(search).get("login") === "form" ? "" : idpHint;
}

export function logout(): void {
  // With the trailing slash: Keycloak matches it against the client's `<origin>/*` pattern.
  void keycloak.logout({ redirectUri: `${window.location.origin}/` });
}
